package com.patronat.top.features.auth.data.mappers

import com.patronat.top.core.domain.usecase.command.auth.ConfirmEmailCommand
import com.patronat.top.core.domain.usecase.command.auth.ConfirmPhoneCommand
import com.patronat.top.core.domain.usecase.command.auth.LoginCommand
import com.patronat.top.core.domain.usecase.command.auth.RegistrationUserCommand
import com.patronat.top.core.domain.usecase.command.auth.SendCodeToEmailCommand
import com.patronat.top.core.domain.usecase.command.auth.SendCodeToPhoneCommand
import com.patronat.top.dto.*
import com.patronat.top.features.auth.domain.models.AuthResult


fun RegistrationUserCommand.toRequest(): RegisterRequest {
    return RegisterRequest(
        firstName = this.firstName,
        lastName = this.lastName,
        phoneNumber = this.phone,
        email = this.email,
        userRole = this.role
    )
}

fun LoginCommand.toRequest(): LoginRequest {
    return LoginRequest(
        login = this.login,
        authMethod = this.authMethod
    )
}

fun ConfirmPhoneCommand.toRequest(): PhoneNumberConfirmRequest {
    return PhoneNumberConfirmRequest(
        phoneNumber = this.phone,
        code = this.code,
        flow = this.flow
    )
}

fun ConfirmEmailCommand.toRequest(): EmailConfirmRequest {
    return EmailConfirmRequest(
        email = this.email,
        code = this.code,
        flow = this.flow
    )
}

fun SendCodeToPhoneCommand.toRequest(): ResendPhoneCodeRequest {
    return ResendPhoneCodeRequest(
        phone = this.phone
    )
}

fun SendCodeToEmailCommand.toRequest(): ResendEmailCodeRequest {
    return ResendEmailCodeRequest(
        email = this.email
    )
}

fun AuthResponse.toDomain(): AuthResult {
    return when (this) {
        is AuthSuccessResponse -> AuthResult.Success(this.userRole)
        is AuthActionResponse -> AuthResult.Continue(
            nextStep = this.nextStep,
            isOtpSent = this.isOtpSent
        )
    }
}

fun AuthActionResponse.toDomain(): AuthResult.Continue {
    return AuthResult.Continue(
        nextStep = this.nextStep,
        isOtpSent = this.isOtpSent
    )
}
